<template>
  <router-link
    :to="path"
    :disabled="is_disabled"
    :id="id"
    :class="[
      button_class,
      'px-4 py-2 rounded-[30px] min-w-20 h-fit text-center bg-black text-white border-b border-r border-white hover:shadow-lg hover:shadow-white/70 transition-shadow duration-500',
    ]"
  >
    {{ button_text }}
  </router-link>
</template>

<script>
export default {
  props: {
    is_disabled: Boolean,
    button_class: String,
    button_text: String,
    path: String,
    id: String,
  },
};
</script>
